/*
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */

import { MeasureUnit } from '../../interaction/measure.interaction';

export class MeasurementValue {
    value = 0;
    units: MeasureUnit;

    constructor(value: number, units?: MeasureUnit) {
        this.value = value;
        if (units) {
            this.units = units;
        }
    }

    get label() {
        const valueString = this.value.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: true,
        });
        return `${valueString} ${this.getUnitLabel()}`;
    }

    private getUnitLabel(): string {
        switch (this.units) {
            case 'm':
            case 'km':
            case 'ft':
            case 'mi':
                return this.units;
            case 'sqm':
                return 'm²';
            case 'sqkm':
                return 'km²';
            case 'sqft':
                return 'ft²';
            case 'sqmi':
                return 'mi²';
            case 'acre':
                return this.value <= 1 ? 'acre' : 'acres';
            default:
                return this.units;
        }
    }
}
